import { __assign, __awaiter, __generator, __values } from "tslib";
import React from "react";
import { Avatar } from "@hose/eui";
import { getAIAgent } from '../plugins/bills/bills.action';
import styles from './ai-agent-utils.module.less';
import { toJS, isObservableObject } from 'mobx';
import { cloneDeep } from 'lodash';
import classNames from 'classnames';
export var getAIAgentObj = function (node, nodesAIAgentMap) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (nodesAIAgentMap === void 0) { nodesAIAgentMap = {}; }
    var agent;
    var agentTitle;
    var aiAgentId = ((_c = (_b = (_a = node === null || node === void 0 ? void 0 : node.ebotConfig) === null || _a === void 0 ? void 0 : _a.setting) === null || _b === void 0 ? void 0 : _b.extras) === null || _c === void 0 ? void 0 : _c.aiAgent) || ((_e = (_d = node === null || node === void 0 ? void 0 : node.ebotConfig) === null || _d === void 0 ? void 0 : _d.setting) === null || _e === void 0 ? void 0 : _e.aiAgent) || ((_g = (_f = node === null || node === void 0 ? void 0 : node.attributes) === null || _f === void 0 ? void 0 : _f.extras) === null || _g === void 0 ? void 0 : _g.aiAgent);
    if (aiAgentId) {
        if (typeof aiAgentId === 'string' && aiAgentId in nodesAIAgentMap) {
            agent = nodesAIAgentMap[aiAgentId] || {
                name: i18n.get('匹配不到智能体'),
                icon: 'EBotIconNode'
            };
        }
        else if (typeof aiAgentId === 'object' && aiAgentId !== null) {
            agent = aiAgentId;
        }
        else {
            agent = null;
        }
    }
    if (agent) {
        agentTitle = React.createElement("div", { className: styles['ai-agent-title'] },
            React.createElement(Avatar, { size: "mini", shape: "circle", src: agent === null || agent === void 0 ? void 0 : agent.icon }, agent === null || agent === void 0 ? void 0 : agent.name),
            React.createElement("span", null, agent === null || agent === void 0 ? void 0 : agent.name));
    }
    else {
        agentTitle = i18n.get('匹配不到智能体，将自动跳过');
    }
    return {
        agentTitle: agentTitle,
        agent: agent,
        avatar: React.createElement(Avatar, { size: "large", shape: "circle", src: agent === null || agent === void 0 ? void 0 : agent.icon }, agent === null || agent === void 0 ? void 0 : agent.name)
    };
};
export var AIAgentTag = function (_a) {
    var text = _a.text, style = _a.style;
    return React.createElement("div", { className: classNames('ai-agent-label-tag', styles['ai-agent-label-tag']), style: style },
        React.createElement("span", { className: classNames('ai-agent-label-tag-text', styles['ai-agent-label-tag-text']) }, text));
};
export var getAIAgentLabelDom = function (langName, isBold) {
    if (isBold === void 0) { isBold = false; }
    return React.createElement("span", { className: styles['ai-agent-label'] + " " + (isBold && styles['bold']) },
        React.createElement("span", { className: styles['ai-agent-label-name'] }, langName),
        React.createElement(AIAgentTag, { text: 'AI' }));
};
export var fetchNodesAIAgentMap = function (nodesAIAgentMap, nodes, logs) {
    if (nodesAIAgentMap === void 0) { nodesAIAgentMap = {}; }
    if (nodes === void 0) { nodes = []; }
    return __awaiter(void 0, void 0, void 0, function () {
        var map, nodes_1, nodes_1_1, node, aiAgentId, res, e_1_1, logs_1, logs_1_1, log, aiAgentId, res, e_2_1;
        var e_1, _a, e_2, _b;
        var _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    map = __assign({}, nodesAIAgentMap);
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 7, 8, 9]);
                    nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next();
                    _l.label = 2;
                case 2:
                    if (!!nodes_1_1.done) return [3, 6];
                    node = nodes_1_1.value;
                    aiAgentId = ((_e = (_d = (_c = node === null || node === void 0 ? void 0 : node.ebotConfig) === null || _c === void 0 ? void 0 : _c.setting) === null || _d === void 0 ? void 0 : _d.extras) === null || _e === void 0 ? void 0 : _e.aiAgent) || ((_g = (_f = node === null || node === void 0 ? void 0 : node.ebotConfig) === null || _f === void 0 ? void 0 : _f.setting) === null || _g === void 0 ? void 0 : _g.aiAgent);
                    if (!(node.type === 'aiApproval' && aiAgentId && !map[aiAgentId])) return [3, 5];
                    if (!(typeof aiAgentId === 'string')) return [3, 4];
                    return [4, getAIAgent({ id: aiAgentId })];
                case 3:
                    res = _l.sent();
                    if (res.code === 200) {
                        map[aiAgentId] = res.data;
                    }
                    return [3, 5];
                case 4:
                    map[aiAgentId === null || aiAgentId === void 0 ? void 0 : aiAgentId.id] = aiAgentId;
                    _l.label = 5;
                case 5:
                    nodes_1_1 = nodes_1.next();
                    return [3, 2];
                case 6: return [3, 9];
                case 7:
                    e_1_1 = _l.sent();
                    e_1 = { error: e_1_1 };
                    return [3, 9];
                case 8:
                    try {
                        if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7];
                case 9:
                    if (!Array.isArray(logs)) return [3, 17];
                    _l.label = 10;
                case 10:
                    _l.trys.push([10, 15, 16, 17]);
                    logs_1 = __values(logs), logs_1_1 = logs_1.next();
                    _l.label = 11;
                case 11:
                    if (!!logs_1_1.done) return [3, 14];
                    log = logs_1_1.value;
                    aiAgentId = (_j = (_h = log === null || log === void 0 ? void 0 : log.attributes) === null || _h === void 0 ? void 0 : _h.extras) === null || _j === void 0 ? void 0 : _j.aiAgent;
                    if (!(((_k = log.attributes) === null || _k === void 0 ? void 0 : _k.nodeType) === 'AIAPPROVAL' && aiAgentId && !map[aiAgentId])) return [3, 13];
                    return [4, getAIAgent({ id: aiAgentId })];
                case 12:
                    res = _l.sent();
                    if (res.code === 200) {
                        map[aiAgentId] = res.data;
                    }
                    _l.label = 13;
                case 13:
                    logs_1_1 = logs_1.next();
                    return [3, 11];
                case 14: return [3, 17];
                case 15:
                    e_2_1 = _l.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 17];
                case 16:
                    try {
                        if (logs_1_1 && !logs_1_1.done && (_b = logs_1.return)) _b.call(logs_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7];
                case 17: return [2, map];
            }
        });
    });
};
export var getFlowPlanFromLogs = function (plan, logs) {
    var _a;
    var isRetract = logs && logs.length > 0 && logs[logs.length - 1].action === 'freeflow.retract';
    if (isObservableObject(plan)) {
        plan = toJS(plan);
    }
    var flowPlan = cloneDeep(plan);
    var taskId = flowPlan === null || flowPlan === void 0 ? void 0 : flowPlan.taskId;
    var prevId = flowPlan === null || flowPlan === void 0 ? void 0 : flowPlan.prevId;
    (_a = flowPlan === null || flowPlan === void 0 ? void 0 : flowPlan.nodes) === null || _a === void 0 ? void 0 : _a.reduce(function (prev, next) {
        if (prevId === 'SUBMIT' && taskId === next.id) {
            if (prev.stateEx === undefined) {
                prev.stateEx = 'done';
            }
            next.stateEx = 'now';
            return next;
        }
        if (taskId === 'SUBMIT' && prevId === prev.id) {
            prev.stateEx = isRetract ? 'retract' : 'reject';
            next.stateEx = '';
            return next;
        }
        if (flowPlan.nodes.length === 1 && taskId === 'SUBMIT' && prevId === next.id) {
            next.stateEx = isRetract ? 'retract' : 'reject';
            return next;
        }
        if (prev.stateEx === 'now' || prev.stateEx === '') {
            next.stateEx = '';
            return next;
        }
        if (next.id === prevId) {
            if (taskId === null) {
                next.stateEx = 'done';
            }
            else if (taskId === 'SUBMIT') {
                next.stateEx = isRetract ? 'retract' : 'reject';
            }
            prev.stateEx = 'done';
            return next;
        }
        if (prev.id === prevId && next.id === taskId) {
            prev.stateEx = 'done';
            next.stateEx = 'now';
            return next;
        }
        if ((prev.skippedType === 'APPROVER_NOT_FOUND_BY_ROLE' ||
            prev.skippedType === 'APPROVER_SAME_AS_SUBMITTER_BY_ROLE') &&
            next.id === taskId) {
            next.stateEx = 'now';
        }
        if (next.id === taskId) {
            prev.stateEx = 'done';
            next.stateEx = 'now';
        }
        prev.stateEx = 'done';
        return next;
    }, { id: 'SUBMIT' });
    return flowPlan;
};
export var isAIAgentNode = function (el) {
    var _a, _b;
    return ((_a = el === null || el === void 0 ? void 0 : el.node) === null || _a === void 0 ? void 0 : _a.type) === 'aiApproval' || ((_b = el === null || el === void 0 ? void 0 : el.attributes) === null || _b === void 0 ? void 0 : _b.nodeType) === "AIAPPROVAL";
};
export var getSkippedNodeStaff = function (node) {
    var _a, _b;
    return (_b = (_a = node === null || node === void 0 ? void 0 : node.attributes) === null || _a === void 0 ? void 0 : _a.nodeApproverIds) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({
        avatar: item.avatar,
        name: item.name
    }); });
};
